/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-return */
import axios from 'axios';

import { logout } from '@use-cases/auth';

import { FEATURE_AUTH0_LOGIN, isEnabled } from '@utils/features';

import { StatusCode } from '@backend/modules/domui/types';
import { LogLevel } from '@domui-domain/type';

import { log } from '@hooks/logger';

export const interceptUnAuthenticatedError = (err: any) => {
  const axiosError = axios.isAxiosError(err);
  const isAuth0LoginEnabled = isEnabled(FEATURE_AUTH0_LOGIN);
  if (axiosError) {
    const errorResponse = err?.response;
    if (errorResponse) {
      const errorStatus = errorResponse.status;
      const statusCode = errorResponse.data?.status;
      if (
        errorStatus === 401 &&
        statusCode === StatusCode.UserNotAuthenticated
      ) {
        // Logout gracefully when user is not authenticated.
        log({
          level: LogLevel.Info,
          message:
            'interceptUnAuthenticatedError, Logout due to session timeout',
        });
        window.localStorage.setItem('sessionExpired', 'set');
        if (isAuth0LoginEnabled) {
          // Clear auth login flag so next login works properly
          localStorage.removeItem('auth0_login_processed');
        }
        const path = window?.location?.pathname || '';
        const noLanguagePath = path
          ? path.replace(/^\/[a-z]{2}(?=\/)/i, '')
          : '';
        logout(`DomuiLogout:${noLanguagePath}`);
        return;
      }
    }
  }
};
